import dayjs from 'dayjs';

import Typography from '~/components/Typography';

interface Props {
  timestamp: string;
  readTime?: string;
  color: string;
  fontFamily: string;
}

const formatPostTime = (postTime: dayjs.Dayjs) => {
  const now = dayjs();
  const diffHours = now.diff(postTime, 'hour');
  const isToday = diffHours < 24;
  if (diffHours <= 1) return `${diffHours ? diffHours : 1} hour ago`;
  if (isToday) return `${diffHours} hours ago`;
  return postTime.locale('en').format('MMM DD, YYYY');
};

const PostDetails = ({ timestamp, readTime, fontFamily, color }: Props) => {
  const postTime = dayjs(timestamp);
  const formattedTime = formatPostTime(postTime);

  return (
    <div className="flex items-center space-x-1">
      <Typography
        as="span"
        size="xs"
        weight="light"
        className="!text-xs text-gray-600"
        fontFamily={fontFamily}
        fontFamilyv2={fontFamily}
        color={color}
      >
        <time dateTime={timestamp}>{formattedTime}</time>
      </Typography>
      {readTime && (
        <>
          <div>
            <div
              className="h-1 w-1 rounded-full"
              style={{
                backgroundColor: color,
              }}
            />
          </div>
          <Typography
            as="span"
            size="xs"
            weight="light"
            className="!text-xs text-gray-600"
            fontFamily={fontFamily}
            fontFamilyv2={fontFamily}
            color={color}
          >
            {readTime}
          </Typography>
        </>
      )}
    </div>
  );
};

export default PostDetails;
